import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import Modal from '../../components/Modal';
import Request from '../../utils/request';

const SELECTOR_PAGE = '.js-my-favourites';
const SELECTOR_FAVOURITE_PLAYED_LIST = '.js-favourite-players-grid';
const SELECTOR_RECENTLY_PLAYED_LIST = '.js-recently-played-grid';
const SELECTOR_FAVOURITE_PLAYER_REMOVE = '.js-favourite-player-remove';
const SELECTOR_FAVOURITE_PLAYER_SAVE = '.js-favourite-player-save';
const SELECTOR_FAVOURITE_PLAYER_CARD = '.lta-favourite-player-card';

const ADD_FAVOURITE_PLAYER_BUTTON = ".js-add-fav-player-button";

const EVENT_FAVPLAYER_ADDED = "lta.PlayerSearch-FavouritePlayerAdded";
const CLOSE_FAVOURITE_PLAYER_BUTTON = ".js-my-favourite-player-cancel";
const CLOSE_FAVOURITE_PLAYER_ICON = ".js-exit-favourite-player-modal";
const SELECTOR_ADD_FAVOURITE_MODAL = "#add-favourite-player-modal";
const ADD_FAVOURITE_MODAL_BUTTON = '.js-lta-play-add-fav-btn';

const EVENT_CLICK = `click`;

class FavouritePlayer {
	constructor() {
		this._myContactId = undefined;
		this.init();
	}

	init() {
		this._wrapperElement = SelectorEngine.findOne(SELECTOR_PAGE);
		if (!this._wrapperElement) {
			return;
		}
		this._myContactId = this._wrapperElement.getAttribute('data-my-favourites-contact-id');
		this._favouritePlayersList = SelectorEngine.findOne(SELECTOR_FAVOURITE_PLAYED_LIST, this._wrapperElement);
		this._recentlyPlayedList = SelectorEngine.findOne(SELECTOR_RECENTLY_PLAYED_LIST, this._wrapperElement);

		this._addFavouriteModal = new Modal(SelectorEngine.findOne(SELECTOR_ADD_FAVOURITE_MODAL, this._wrapperElement), {});
		this._addFavouriteButton = SelectorEngine.findOne(ADD_FAVOURITE_PLAYER_BUTTON, this._wrapperElement);
		this._addFavouriteModalButton = SelectorEngine.findOne(ADD_FAVOURITE_MODAL_BUTTON, this._wrapperElement);
		this._closeFavouriteButton = SelectorEngine.findOne(CLOSE_FAVOURITE_PLAYER_BUTTON, this._wrapperElement);
		this._closeFavouriteIcon = SelectorEngine.findOne(CLOSE_FAVOURITE_PLAYER_ICON, this._wrapperElement);

		EventHandler.on(this._addFavouriteButton, EVENT_CLICK, () => {
			this.showAddFavouriteModal();
		});

		EventHandler.on(this._closeFavouriteIcon, EVENT_CLICK, () => {
			this.closeAddFavouriteModal();
		});
		
		EventHandler.on(this._addFavouriteModalButton, EVENT_FAVPLAYER_ADDED, () => {
			this.closeAddFavouriteModal();
		});

		EventHandler.on(this._addFavouriteModalButton, EVENT_CLICK, () => {
		//	this.closeAddFavouriteModal();
		});

		EventHandler.on(this._closeFavouriteButton, EVENT_CLICK, () => {
			this.closeAddFavouriteModal();
		});

		this.fetchFavouritePlayer();
	}

	showAddFavouriteModal(){
		this._addFavouriteModal.show();
	}

	closeAddFavouriteModal() {
		this._addFavouriteModal.hide();
		this.fetchFavouritePlayer();
		this.fetchRecentlyPlayed();
		//setTimeout(() => location.reload(true), 300);
	}

	set favouritePlayerData(data) {
		this._favouritePlayerData = data;
		this.renderFavouritePlayer();
	}

	get favouritePlayerData() {
		return this._favouritePlayerData;
	}

	set recentlyPlayedData(data) {
		this._recentlyPlayedData = data;
		this.renderRecentlyPlayed();
	}

	get recentlyPlayedData() {
		return this._recentlyPlayedData;
	}

	async fetchFavouritePlayer() {
			// USE FOR PRODUCTION
			try {
				const result = await Request.get(
					`/api/selfsubmission/getfavouriteplayerbycontactid?ContactId=${this._myContactId}`
				).catch(error => console.log(error));
	
				const response = result;
	
				if (response?.errors?.errorcode == '00') {
					this.favouritePlayerData = response.response.favourites;
				}
			} 
			catch (error) {
				console.log(error);
			}
			finally {
				this.fetchRecentlyPlayed();
			}
	}

	async fetchRecentlyPlayed() {
			// USE FOR PRODUCTION
			 const result = await Request.get(
			 	`/api/selfsubmission/getrecentlyplayedbycontactid?contactId=${this._myContactId}`
			 ).catch(error => console.log(error));

			const response = result;
			if (response?.errors?.errorcode == '00') {
				this.recentlyPlayedData = response.response.RecentlyPlayed;
			}
	}

	async removeFavouritePlayer(card) {
		const postData = {
			'ContactId': this._myContactId,
			'favourites': [card.id]
		};

		// USE FOR PRODUCTION
		const data = await Request.post('/api/selfsubmission/Deletefavouriteplayerbycontactid', postData).catch(error =>
			console.log(error.errors.errormessage));

		if(data) {
			this.fetchFavouritePlayer();
		}
	}

	async saveFavouritePlayer(card) {
		const postData = {
			'ContactId': this._myContactId,
			'favourites': [card.id]
		};
		// USE FOR PRODUCTION
		const savedPlayer = await Request.post('/api/selfsubmission/Setfavouriteplayerbycontactid', postData).catch(error => console.log(error));

		if(savedPlayer) {
			if(savedPlayer.errors.errorcode == '01') {
				this.errorMsgEl = SelectorEngine.findOne('.js-maximum-player-error-message', this._wrapperElement);
				this.errorMsgEl.classList.remove('u-hidden')
				this.errorMsgEl.innerHTML = savedPlayer.response.message;
				setTimeout(() => {
					this.errorMsgEl.classList.add('u-hidden');
				}, 5000);
			}
			this.fetchFavouritePlayer();
		}
	}

	renderFavouritePlayer() {
		if(this.favouritePlayerData == null) {
			this._favouritePlayersList.innerHTML = 'No favourites for this contact';
		} else {
			this._favouritePlayersList.innerHTML = this.favouritePlayerData.map((item) => this.renderFavouritePlayerRow(item)).join('');
			this.getFavouriteSaveButton();
		}
	}

	getFavouriteSaveButton() {
		this._favouritePlayersCard = SelectorEngine.find(SELECTOR_FAVOURITE_PLAYER_CARD, this._favouritePlayersList);
		this._favouritePlayersCard.forEach((card) => {
			const _saveFavouriteButton = SelectorEngine.findOne(SELECTOR_FAVOURITE_PLAYER_REMOVE, card);
			EventHandler.on(_saveFavouriteButton, EVENT_CLICK, () => {
				this.removeFavouritePlayer(card);
			});
		});
	}

	renderRecentlyPlayed() {
			this._recentlyPlayedList.innerHTML = this.recentlyPlayedData.map(item => this.renderRecentlyPlayedRow(item, this.favouritePlayerData)).join('');
			this.getRecentlySaveButton();
		}

	getRecentlySaveButton() {
		this._recentlyPlayedCard = SelectorEngine.find(SELECTOR_FAVOURITE_PLAYER_CARD, this._recentlyPlayedList);
		this._recentlyPlayedCard.forEach((card) => {
			const _removeFavouriteButton = SelectorEngine.findOne(SELECTOR_FAVOURITE_PLAYER_SAVE, card);
			EventHandler.on(_removeFavouriteButton, EVENT_CLICK, () => {
				this.saveFavouritePlayer(card);
			});
		});
	}

	renderPlayerName(itemData) {
		return `<b>${itemData.firstname} ${itemData.lastname} (${itemData.gender})</b><br>`;
	}

	renderAdvantageNumber(itemData) {
		if (!itemData.ltanumber) {
			return ``;
		}
		return `Advantage number: <b>${itemData.ltanumber}</b> <br>`;
	}

	renderAddress(itemData) {
		let city = '';
		let country = '';
		if (itemData.city) {
			city = itemData.city;
		}
		if (itemData.country) {
			country = ', ' + itemData.country;
		}
		return `${city} ${country}`;
	}

	renderWTNNumber(itemData) {
		let WTNValue;
		if (!itemData.singleswtn && !itemData.doubleswtn) {
			return ``;
		} else {
			if (itemData.singleswtn) {
				WTNValue = `<p class="u-mr-1">Singles <b>${itemData.singleswtn}</b></p>`;
			}
			if (itemData.doubleswtn) {
				WTNValue = WTNValue + `<p>Doubles <b>${itemData.doubleswtn}</b></p>`;
			}
		}
		return `<div class="u-flex">
					<img
						alt="Alt text"
						loading="lazy"
						decoding="async"
						class="u-mr-1"
						src="/static/images/logos/wtn.png"></img>
					WTN number:
				</div>
				<div class="u-flex u-mb-2">
					${WTNValue}
				</div>`;
	}

	renderLastPlayedDate(itemData) {
		if (!itemData.lastplayeddate) {
			return ``;
		}
		return `<p class="u-mb-1">Last Played: <span>${itemData.lastplayeddate}</span></p>`;
	}

	renderFavouritePlayerRow(itemData) {
		return `<div id=${itemData.id} class="lta-favourite-player-card u-mr-3 u-mb-3 u-bg-background-blue u-px-3 u-py-2 u-label1 u-text-lta-dark-blue u-flex" style="flex-direction:column;">
					<p class="u-mb-2 u-flex-grow">
						${this.renderPlayerName(itemData)}
						${this.renderAdvantageNumber(itemData)}
						${this.renderAddress(itemData)}
					</p>
					${this.renderWTNNumber(itemData)}
					${this.renderLastPlayedDate(itemData)}
					<button type="button" class="lta-btn lta-btn--md lta-btn--pettie lta-btn--icon lta-btn--icon-before lta-btn--xs l-btn-grey-text u-border-1 u-mt-2 u-p-1 u-rounded u-label1 js-favourite-player-remove" title="Remove as favourite">
					<svg class="lta-icon js-lta-text-input--btn-icon u-mr-1 " width="1.30em" height="1.30em" fill="currentColor" alt="close" aria-hidden="true">
						<use xlink:href="/static/images/icons/lta-icons.svg#close"></use>
					</svg>
						Remove as favourite
					</button>
				</div>`;
	}

	renderRecentlyPlayedRow(itemData, favouritePlayerData) {
		let disabled = 'disabled';
		if(JSON.stringify(favouritePlayerData).includes(itemData.id)) {
			return `<div id=${itemData.id} class="lta-favourite-player-card u-mr-3 u-mb-3 u-bg-background-white u-rounded u-border u-px-3 u-py-2 u-label1 u-text-lta-dark-blue u-flex" style="flex-direction: column;">
						<p class="u-mb-2 u-flex-grow">
							${this.renderPlayerName(itemData)}
							${this.renderAdvantageNumber(itemData)}
						</p>
						<button type="button" disabled class="lta-btn lta-btn--xs lta-btn--petite-inverse lta-btn--icon lta-btn--icon-before js-favourite-player-save" title="Save as favourite">
						<svg class="lta-icon js-lta-text-input--btn-icon u-mr-1" width="1.30em" height="1.30em" fill="currentColor" alt="heart" aria-hidden="true">
							<use xlink:href="/static/images/icons/lta-icons.svg#heart"></use>
						</svg>
						Save as favourite
						</button>
					</div>`;
				} else {
					return `<div id=${itemData.id} class="lta-favourite-player-card u-mr-3 u-mb-3 u-bg-background-white u-rounded u-border u-px-3 u-py-2 u-label1 u-text-lta-dark-blue u-flex" style="flex-direction: column;">
								<p class="u-mb-2 u-flex-grow">
									${this.renderPlayerName(itemData)}
									${this.renderAdvantageNumber(itemData)}
								</p>
								<button type="button" class="lta-btn lta-btn--xs lta-btn--petite lta-btn--icon lta-btn--icon-before js-favourite-player-save" title="Save as favourite">
								<svg class="lta-icon js-lta-text-input--btn-icon u-mr-1" width="1.30em" height="1.30em" fill="currentColor" alt="heart" aria-hidden="true">
									<use xlink:href="/static/images/icons/lta-icons.svg#heart"></use>
								</svg>
								Save as favourite
								</button>
							</div>`;
		}
		
	}
}

const globalFavouritePlayer = new FavouritePlayer();
export default globalFavouritePlayer;
